import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ChevronDown } from "lucide-react";

/** Reusable 925x53 pill search bar used by the homepage hero and other hero banners. */
export default function HeroSearchPill({ autoFocus = false, testId = "hero-search" }) {
  const [q, setQ] = useState("");
  const nav = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const query = q.trim();
    if (!query) return;
    nav(`/dashboard/search?q=${encodeURIComponent(query)}`);
  };

  return (
    <form
      onSubmit={submit}
      data-testid={`${testId}-form`}
      className="w-full mx-auto flex items-stretch bg-ivory overflow-hidden shadow-2xl ring-1 ring-white/10"
      style={{ maxWidth: "925px", height: "53px", borderRadius: "28px" }}
    >
      <div className="flex items-center gap-1.5 pl-5 pr-3 text-sm text-ink border-r border-border shrink-0">
        Photos <ChevronDown className="h-3.5 w-3.5" />
      </div>
      <div className="flex items-center flex-1 min-w-0 pl-3">
        <Search className="h-4 w-4 text-muted-foreground shrink-0" />
        <input
          data-testid={`${testId}-input`}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder='Try "misty forest", "morning coffee"'
          className="flex-1 h-full px-3 text-sm md:text-base outline-none bg-transparent text-ink placeholder:text-muted-foreground"
          autoFocus={autoFocus}
        />
      </div>
      <button
        type="submit"
        data-testid={`${testId}-submit`}
        className="px-6 md:px-8 bg-gold text-ivory hover:bg-gold/90 transition-colors text-sm tracking-wide shrink-0"
      >
        Search
      </button>
    </form>
  );
}
